import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

const StBlockWithShadow = styled.div``

const StAvatar = styled.div`
  position: relative;
  padding-bottom: 130%;
  position: relative;
  background-color: white;
  > div {
    position: relative;
    z-index: 1;
    background-color: white;
  }
  &::after {
    content: '';
    position: absolute;
    background-color: red;
    top: -14px;
    left: -14px;
    bottom: 14px;
    right: 14px;
  }
  .gatsby-image-wrapper {
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    top: 0;
    left: 0;
  }
`

const Author = ({ data }) => {
  const { avatar, fullname, title } = data
  return (
    <StBlockWithShadow className="mb-4 mt-8">
      <div className="pb-2 mx-auto">
        <StAvatar>
          <Img className="block w-full" fixed={avatar.childImageSharp.fixed} />
        </StAvatar>
      </div>
      <div className="col-span-3">
        <h4 className="font-bold text-sm leading-none">{fullname}</h4>
        {title && <h4 className="block text-xs leading-none p-2">{title}</h4>}
      </div>
    </StBlockWithShadow>
  )
}

export default Author
